import { Lesson, Training } from '@/app/entities/Training'
import { ReactNode, createContext, useContext, useState } from 'react'

interface LessonListContextProps {
  training: Training
  currentLesson: Lesson
  setCurrentLesson: (lesson: Lesson) => void
  lessons: Lesson[]
}

interface LessonListProviderProps {
  children: ReactNode
  lessons: Lesson[]
  training: Training
}

export const LessonListContext = createContext({} as LessonListContextProps)

export function LessonListProvider({
  children,
  lessons,
  training,
}: LessonListProviderProps) {
  const [currentLesson, setCurrentLesson] = useState<Lesson>(lessons[0])

  return (
    <LessonListContext.Provider
      value={{ currentLesson, setCurrentLesson, lessons, training }}
    >
      {children}
    </LessonListContext.Provider>
  )
}

export function useLessonList() {
  const context = useContext(LessonListContext)
  if (!context) {
    throw new Error('useLessonList must be used within a LessonListProvider')
  }
  return context
}
